import { BReactComponent } from 'blocks-cloud/b-react-component';

import { UploadBlock } from '../UploadBlock/UploadBlock';

export class UploadDropAreaToolkit {
    component = null;
    isRendered = false;
    el = null;

    constructor() {
        this.component = new BReactComponent({
            ReactComponent: UploadBlock,
            renderMode: 'append',
        });
    }

    render(props) {
        if (!this.isRendered) {
            const block = document.getElementById('uploadDropArea');

            if (!block) {
                return;
            }
            
            this.el = document.createElement('div');
            block.appendChild(this.el);
            this.isRendered = true;
        }

        this.component.renderTo(this.el, {
            props,
        });
    }

    destroy() {
        this.component.destroy();
    }
}
